import { saveUserCache } from '@/lib/storageUtil';
import Paths from '@/routes/paths';
import useLogout from '@authentication/hooks/useLogout';
import useUser from '@authentication/hooks/useUser';
import LoginRequest from '@authentication/models/login.request.dto';
import LoginResponse from '@authentication/models/login.response.dto';
import { login } from '@authentication/services/authServices';
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { useNavigate } from 'react-router-dom';

const useLoginMutation = (): UseMutationResult<
  AxiosResponse<LoginResponse>,
  unknown,
  LoginRequest,
  unknown
> => {
  const { setUser, setIsLoading } = useUser();
  const navigate = useNavigate();

  const logout = useLogout();

  const onLoginSuccess = ({ data }: { data: LoginResponse }) => {
    setUser(data.user);
    saveUserCache(data);
    setIsLoading(false);
    navigate(Paths.DashboardPage);
  };

  const onLoginError = () => {
    logout();
    setUser(null);
    setIsLoading(false);
  };
  const loginMutation = useMutation({
    mutationFn: login,
    onSuccess: onLoginSuccess,
    onError: onLoginError,
  });

  return loginMutation;
};

export default useLoginMutation;
